module.exports = __webpack_public_path__ + "static/img/inform_1@2x.af47b3c9.png";